module.exports = __webpack_public_path__ + "assets/444fbb1d5ad0f8e94929bf71fc362c02.png";